<div>
  <span>Each entry into the campaign is linked to a </span>
  <span class="font-bold">{{ campaignSubject() }}. </span>
  <span>Re-entry and Conversions are tracked for each </span>
  <span class="font-bold">{{ reentryScope() }}. </span>
  @if (campaignSubject() !== patientSubject) {
    <span>If a Patient has multiple </span>
    <span class="font-bold">{{ campaignSubject() }}s </span>
    <span
      >entered in the campaign, they will be contacted for each separately.
      Re-entry and Conversions are tracked separately for each
    </span>
    <span class="font-bold">{{ reentryScope() }}. </span>
  }
</div>

@if (stepSummary(); as stepSummaryValue) {
  <div class="flex flex-row items-center gap-2">
    <mat-icon class="icon-sm shrink-0 opacity-50">timelapse</mat-icon>
    <div class="flex grow">
      <pr-campaign-steps-summary [stepSummary]="stepSummaryValue" />
    </div>
  </div>
}

<div class="flex flex-row items-center gap-2">
  <mat-icon class="icon-sm shrink-0 opacity-50">refresh</mat-icon>
  <div class="flex grow">
    <span
      >Each <span class="font-bold">{{ reentryScope() }}</span> can be enrolled
      in the campaign
      @if (campaign().entryResetRules.multipleEntry) {
        <span>once every </span>
        <span class="font-bold"
          >{{ campaign().entryResetRules.frequencyCount }}
          {{
            campaign().entryResetRules.frequencyType
              | map: frequencyLabel : this
          }}.
        </span>
        @if (campaign().entryResetRules.maxEntryCount) {
          <span>Up to </span>
          <span class="font-bold"
            >{{ campaign().entryResetRules.maxEntryCount }} times.</span
          >
        }
      } @else {
        <span class="font-bold">once.</span>
      }
    </span>
  </div>
</div>

<div class="flex flex-row items-center gap-2">
  <mat-icon
    class="icon-sm shrink-0 opacity-50"
    fontSet="material-symbols-outlined"
  >
    productivity
  </mat-icon>
  <div class="flex grow">
    @if (campaign().conversionType; as conversionType) {
      <span>
        <span>{{ reentryScope() }}s are converted when </span>
        <span class="font-bold"
          >{{ conversionType | splitCamel | titlecase }}.
        </span>
        <span>Any remaining steps will be skipped, and the </span>
        <span class="font-bold">{{ reentryScope() }} </span>
        <span>will no longer be eligible for re-entry into the campaign.</span>
      </span>
    } @else {
      <span>
        <span>{{ reentryScope() }}s are converted when </span>
        <span class="font-bold">manually marked as converted</span>.
      </span>
    }
  </div>
</div>
